import type { IAPIRoutes } from "../../../../config";
import type { IAmplifyProvider } from "../providers/amplifyProvider";

export type INotificationRepository = ReturnType<
  typeof NotificationRepositoryFactory
>;

export const NotificationRepositoryFactory = ({
  APIProvider,
  AuthService,
  amplifyProvider,
  APIRoutes,
}: {
  APIProvider: IAPIProvider;
  AuthService: IAuthService;
  amplifyProvider: IAmplifyProvider;
  APIRoutes: IAPIRoutes;
}) => {
  const { GET, PUT } = APIProvider;
  const { getAuthenticationToken } = AuthService;

  const getNotificationSetting: IGetNotificationSettingAPI = async () => {
    const response = GET(
      APIRoutes.apiGetNotificationSettings,
      {},
      {
        Authorization: `Bearer ${await getAuthenticationToken()}`,
      }
    );
    return response;
  };

  const setNotificationSetting: ISetNotificationSettingAPI = async (
    payload
  ) => {
    const response = PUT(APIRoutes.apiPutNotificationSettings, payload, {
      Authorization: `Bearer ${await getAuthenticationToken()}`,
    });
    return response;
  };

  return {
    getNotificationSetting,
    setNotificationSetting,
  };
};
